import React, { useState, useEffect } from 'react'
import moment from 'moment';
import 'moment-timezone';

import SearchBar from '../components/SearchBar'

export default function OneMinute() {

  const [loading, setLoading] = useState(true);
  const [oneMinEpisodes, setOneMinEpisodes] = useState([]);
  const [searchParam] = useState(["title", "description"]);
  const [query, setQuery] = useState("")
  const episodeUrl = process.env.REACT_APP_ONE_MIN_EPISODE_URL;

  useEffect(() => {
    const oneMinEpisodesUrl = process.env.REACT_APP_ONE_MIN_URL;
    const token = process.env.REACT_APP_TOKEN;

    const requestOptions = {
      method: 'GET',
      redirect: 'follow',
      headers: {
        'Authorization': 'Bearer ' + token
      }
    }

    fetch(oneMinEpisodesUrl, requestOptions)
    .then(response => {
      return response.json()
    })
    .then(data => {
      setOneMinEpisodes(data.collection)
      setLoading(false)
    })
    .catch(error => {
      console.log(error)
    })
  }, [])

  function search(episodes) {
    return episodes.filter((episode) => {
      return searchParam.some((newItem) => {
        return (
          episode[newItem]
            .toString()
            .toLowerCase()
            .indexOf(query.toLowerCase()) > -1
        );
      });
    });
  }

  return (
    <>
      <h1 className="program-title">1-Minute Program</h1>
      <SearchBar query={query} setQuery={setQuery} />

      { loading && <div className="loading"><h1>Loading...</h1></div> }

      <section className="results-container">
        { search(oneMinEpisodes).map((episode) => (
            <div key={episode.token}>
              <a href={ episodeUrl + episode.slug }><h3>{episode.title}</h3></a>
              <p className="bold">Aired {moment.utc(episode.published_at).format('dddd, LL')}</p>
              <p>{episode.description}</p>
              <a className="bold" href={ episodeUrl + episode.slug}>Learn More</a>
              <hr />
            </div>
          ))}
      </section>
    </>
    
  )
}